/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import { List, Map as ImmutableMap, Record, Set as ImmutableSet, is } from 'immutable';
import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { memo, useRef, useEffect } from 'react';
import { getType } from '../../../common-message-format/operators/commonMessageFormatGetters';
import PositionDescriptors from '../../../proptypes/PositionDescriptors';
import SenderMap from '../../../proptypes/SenderMap';
import { LegacyRecipientMapPropType } from '../../../proptypes/RecipientMap';
import AsyncFileAttachmentsMap from '../../../proptypes/AsyncFileAttachmentsMap';
import { MESSAGE_ID_ATTR } from '../../../web/message-history/constants/constants';
import { getMessageId } from '../../../message-history/operators/getMessageId';
import { UNLOADED_MESSAGE } from '../../../unloaded-message/constants/messageTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const shouldRerender = (prev, next) => {
  return !Object.keys(prev).some(key => {
    if (key === 'fileAttachments' || key === 'positionDescriptors' || key === 'senders') {
      return !is(prev[key], next[key]);
    }
    return prev[key] !== next[key];
  });
};
const MessageHistoryItem = /*#__PURE__*/memo(({
  allowContactPromotions,
  fileAttachments,
  fileAttachmentsForThread,
  friendlyNames,
  indexedAsyncFileAttachments,
  hiddenBy,
  historyConfig,
  message,
  portalId,
  positionDescriptors = [],
  presentSenderLocators,
  senders,
  legacyRecipients,
  visitorLastReadTimestamp,
  lastMessageId,
  vid,
  visitorRecipients,
  threadId,
  threadHistory,
  ungatedForChatspot,
  ungatedForNextBestActions,
  ungatedForNewForkedComponent,
  ungatedForOmnichannelCallSummaryAiSkill,
  channelName,
  slots,
  measure
}) => {
  const idAttr = {
    [MESSAGE_ID_ATTR]: getMessageId(message)
  };
  const type = getType(message);
  const Component = historyConfig[type];
  const lastType = useRef(type);
  useEffect(() => {
    if (lastType.current !== type && lastType.current === UNLOADED_MESSAGE) {
      lastType.current = type;
      measure === null || measure === void 0 || measure();
    }
  }, [type, measure]);
  return Component ? /*#__PURE__*/_jsx("div", Object.assign({}, idAttr, {
    children: /*#__PURE__*/_jsx(Component, {
      allowContactPromotions: allowContactPromotions,
      channelName: channelName,
      fileAttachments: fileAttachments,
      fileAttachmentsForThread: fileAttachmentsForThread,
      friendlyNames: friendlyNames,
      hiddenBy: hiddenBy,
      indexedAsyncFileAttachments: indexedAsyncFileAttachments,
      message: message,
      portalId: portalId,
      positionDescriptors: positionDescriptors,
      senders: senders,
      legacyRecipients: legacyRecipients,
      presentSenderLocators: presentSenderLocators,
      visitorLastReadTimestamp: visitorLastReadTimestamp,
      lastMessageId: lastMessageId,
      vid: vid,
      visitorRecipients: visitorRecipients,
      threadId: threadId,
      threadHistory: threadHistory,
      ungatedForChatspot: ungatedForChatspot,
      ungatedForNextBestActions: ungatedForNextBestActions,
      ungatedForNewForkedComponent: ungatedForNewForkedComponent,
      ungatedForOmnichannelCallSummaryAiSkill: ungatedForOmnichannelCallSummaryAiSkill,
      slots: slots,
      onResize: measure
    })
  })) : null;
}, shouldRerender);
MessageHistoryItem.displayName = 'MessageHistoryItem';
MessageHistoryItem.propTypes = {
  allowContactPromotions: PropTypes.bool,
  channelName: PropTypes.string,
  fileAttachments: PropTypes.instanceOf(List),
  fileAttachmentsForThread: PropTypes.instanceOf(ImmutableMap),
  hiddenBy: PropTypes.shape({
    actorId: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired
  }),
  historyConfig: PropTypes.object.isRequired,
  indexedAsyncFileAttachments: AsyncFileAttachmentsMap,
  lastMessageId: PropTypes.string,
  legacyRecipients: LegacyRecipientMapPropType,
  measure: PropTypes.func,
  message: PropTypes.instanceOf(Record).isRequired,
  portalId: PropTypes.number,
  positionDescriptors: PositionDescriptors.isRequired,
  presentSenderLocators: PropTypes.instanceOf(ImmutableSet),
  senders: SenderMap,
  slots: PropTypes.object,
  threadHistory: RecordPropType('ThreadHistory'),
  threadId: PropTypes.string,
  ungatedForChatspot: PropTypes.bool,
  ungatedForNewForkedComponent: PropTypes.bool,
  ungatedForNextBestActions: PropTypes.bool,
  ungatedForOmnichannelCallSummaryAiSkill: PropTypes.bool,
  vid: PropTypes.number,
  visitorLastReadTimestamp: PropTypes.number,
  visitorRecipients: PropTypes.object
};
export default MessageHistoryItem;